"use client";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Chip, IconButton } from "@mui/material";
import React from "react";

import { TableCell, TableRow } from "@/components/molecules/Table/styled";
import useImportationData from "@/hooks/data/use-importation-data";
import usePopOver from "@/hooks/use-popover";
import IImportation from "@/interfaces/importation.interface";
import { ImportationsMessages } from "@/messages/importations/importations.messages";

import { ImportationPopover } from "../Popover";

interface Props {
  importation: IImportation;
  index: number;
  messages: ImportationsMessages;
}

export function ImportationTableRow({ importation, index, messages }: Props) {
  const data = useImportationData({ importation, messages });
  const { openPopover, anchorEl, closePopover, isOpen, selected } = usePopOver<IImportation>();

  return (
    <TableRow index={index}>
      <TableCell>{data.formattedDate}</TableCell>
      <TableCell>{data.formattedSourceType}</TableCell>
      <TableCell>{data.formattedFileName}</TableCell>
      <TableCell>
        <Chip label={data.formattedStatus.toUpperCase()} color={data.bgColor} variant="outlined" />
      </TableCell>
      <TableCell>{data.success}</TableCell>
      <TableCell>{data.error}</TableCell>
      <TableCell>
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            openPopover(e, importation);
          }}
        >
          <MoreHorizIcon />
        </IconButton>
        {selected && (
          <ImportationPopover
            isOpen={isOpen}
            anchorEl={anchorEl}
            onClose={closePopover}
            messages={messages}
            selected={selected}
          />
        )}
      </TableCell>
    </TableRow>
  );
}
